/**
 * upload-porties.js — veel bestanden uploaden in kleine porties in plaats van in één request.
 *
 * Alles in één request ging goed met twintig korte testopnamen, maar niet met honderd echte.
 * De Worker leest een upload in zijn geheel in (request.formData()) en heeft 128 MB geheugen,
 * en Cloudflare neemt op workers.dev niet meer dan 100 MB per request aan. Honderd veldopnamen
 * van een paar MB gaan daar ruim overheen, en dan mislukt de hele upload: niets komt binnen.
 */

/** Ruim onder de 100 MB per request en de 128 MB geheugen van de Worker. */
export const MAX_PORTIE_BYTES = 40 * 1024 * 1024;
/** Klein genoeg dat één trage portie niet lang alles ophoudt. */
export const MAX_PORTIE_BESTANDEN = 5;

/**
 * Verdeel bestanden in porties, in de oorspronkelijke volgorde.
 * Een bestand dat in zijn eentje al groter is dan de grens krijgt een eigen portie; de
 * bestandsgrootte zelf bewaakt de aanroeper (MAX_FILE_SIZE).
 *
 * @param {{ size: number }[]} bestanden
 * @returns {Array<typeof bestanden>}
 */
export function inPorties(bestanden, { maxBestanden = MAX_PORTIE_BESTANDEN, maxBytes = MAX_PORTIE_BYTES } = {}) {
  const porties = [];
  let huidig = [];
  let bytes = 0;
  for (const b of bestanden) {
    const grootte = b.size || 0;
    if (huidig.length && (huidig.length >= maxBestanden || bytes + grootte > maxBytes)) {
      porties.push(huidig);
      huidig = [];
      bytes = 0;
    }
    huidig.push(b);
    bytes += grootte;
  }
  if (huidig.length) porties.push(huidig);
  return porties;
}
